import { connect } from "react-redux";
import React, { useState, useEffect } from "react";
import { withRouter } from "react-router-dom";
import { FormattedMessage } from "react-intl";
import SplashScreen from "../elements/splashScreen/splashScreen.render";
import { CAMPUS_COLLECTION } from "../../reduxStore/actions/main";
import * as mainAction from "../../reduxStore/actions/main";
import LoadingIcon from "../elements/loading/spinner.component";
import { pageNames } from "../../reduxStore/reducers/main";

function MissingCampusLoader(props) {
  const globalParams = new URLSearchParams(props.location.search);
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    if (loading) {
      const page = globalParams.get("page");
      globalParams.delete("page");
      props.history.push(
        `/${pageNames.map}/${page}/?${globalParams.toString()}`
      );
    }
  }, [props.serverDataLoaded]);

  const loadCampusData = () => {
    const allCampusKeys = CAMPUS_COLLECTION.getAllCampuses()
      .map((c) => c.campusKey)
      .concat(globalParams.get("campusKeys").split(","))
      .filter((item, index, self) => self.indexOf(item) === index);

    setLoading(true);
    props.loadCampuses(allCampusKeys, props.language, props.userGroup);
  };

  const cancel = () => {
    globalParams.delete("start");
    globalParams.delete("page");
    globalParams.delete("destination");
    // globalParams.delete("campusKeys");
    props.history.push(
      `/${pageNames.map}/${pageNames.info}/?${globalParams.toString()}`
    );
  };

  return (
    <SplashScreen
      render={() => (
        <div className="p-5 pl-2 pr-2 ">
          <h1 className="text-center">
            <FormattedMessage id="loader.title" />
          </h1>
          <p className="text-center">
            <FormattedMessage id="loader.text" />
          </p>
          <button
            disabled={loading}
            className="w-100 mb-2 text-center btn  align-items-center rounded-5  ca-btn-hollow mb-3 mr-2"
            onClick={cancel}
          >
            <FormattedMessage id="loader.cancel" />
          </button>
          <button
            disabled={loading}
            className="w-100 mb-2 text-center btn align-items-center rounded-5 ca-btn-interact-semi mr-2 mb-3"
            onClick={loadCampusData}
          >
            <FormattedMessage id="loader.confirm" />
          </button>
          <LoadingIcon loading={loading} fullscreen={false} />
        </div>
      )}
    />
  );
}

const mapStateToProps = (state) => {
  return {
    serverDataLoaded: state.main.serverDataLoaded,
    language: state.main.language,
    userGroup: state.settings.routing.userGroup,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    loadCampuses: (keys, lang, userGroup) =>
      dispatch(mainAction.loadCampuses(keys, lang, userGroup)),
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(MissingCampusLoader)
);
